const swrCompareResponse = <T>(res1: T | undefined, res2: T | undefined): boolean => {
  if (typeof res1 !== 'object' && typeof res2 !== 'object') return res1 === res2;

  return JSON.stringify(res1) === JSON.stringify(res2);
};

export default swrCompareResponse;
